
import { FileOpener } from '../plugins/file-opener-fork';
import { File } from '@ionic-native/file';

// angular imports
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

// ionic imports
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { AppVersion } from '@ionic-native/app-version';

import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { NativeStorage } from '@ionic-native/native-storage';
import { Keyboard } from '@ionic-native/keyboard';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { GoogleAnalytics } from '@ionic-native/google-analytics';

// services
import { AnalyticsService } from '../services/analytics.service';
import { MainService } from '../services/main.service';
import { UpdateService } from '../services/update.service';

// pages
import { MyApp } from './app.component';
import { ElectronProvider } from '../providers/electron/electron';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { faBookOpen as faBookOpenLight } from '@fortawesome/pro-light-svg-icons';
import { faBookOpen as faBookOpenSolid } from '@fortawesome/pro-solid-svg-icons';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { faSearchPlus } from '@fortawesome/pro-solid-svg-icons';
import { faPrint } from '@fortawesome/pro-solid-svg-icons';
import { faPencilAlt } from '@fortawesome/pro-solid-svg-icons';
import { faHistory } from '@fortawesome/pro-solid-svg-icons';
import { MenuProvider } from '../providers/menu/menu';
import { AuthProvider } from '../providers/auth/auth';
import { ProfileProvider } from '../providers/profile/profile';
import { NotesProvider } from '../providers/notes/notes';
import { FavouritesProvider } from '../providers/favourites/favourites';
import { PrintProvider } from '../providers/print/print';
import { PrintPdfProvider } from '../providers/print-pdf/print-pdf';
import { ClinicalUpdatesProvider } from '../providers/clinical-updates/clinical-updates';
import { ConnectedProvider } from '../providers/connected/connected';
import { Network } from '@ionic-native/network';
import { Brightness } from '@ionic-native/brightness';
import { PageIndicatorsService } from '../services/page-indicators.service';
import { NetworkService } from '../services/network.service';



library.add(faCoffee, faBookOpenLight, faBookOpenSolid, faChevronRight, faPrint, faPencilAlt, faSearchPlus, faHistory);


@NgModule({
	declarations: [
		MyApp
	],
	imports: [
		BrowserModule,
		HttpModule,
		FontAwesomeModule,
		IonicModule.forRoot(MyApp, {
			platforms: {
				ios: {
					mode: 'md',
					statusbarPadding: true
				},
				cordova: {
					mode: 'md',
					statusbarPadding: true
				},
				android: {
					mode: 'md',
					statusbarPadding: false
				},
				windows: {
					mode: 'md',
					statusbarPadding: false
				}
			}
		}),
	],
	bootstrap: [IonicApp],
	entryComponents: [
		MyApp
	],
	providers: [
		SplashScreen,
		StatusBar,
		AppVersion,
		ScreenOrientation,
		NativeStorage,
		Keyboard,
		InAppBrowser,
		GoogleAnalytics,

		AnalyticsService,
		MainService,
		NetworkService,
		PageIndicatorsService,
		UpdateService,

		{ provide: ErrorHandler, useClass: IonicErrorHandler },
		ElectronProvider,
		MenuProvider,
		AuthProvider,
		ProfileProvider,
		NotesProvider,
		FavouritesProvider,
		PrintProvider,
		File,
		FileOpener,
		PrintPdfProvider,
		ClinicalUpdatesProvider,
		ConnectedProvider,
		Network,
		Brightness,
	]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts